import FUrlBtn from './FUrlBtn.vue'

export default FUrlBtn
